import React from "react";
import { SectionTitle } from "components/items";

import makeTitle from "function/makeTitle.js";

const sectionTitle = [
	{
		text: "OVERVIEW",
		color: "main",
		break: false,
	},
];

const overviewList = [
	{
		data: "400,000",
		text: "월 비누 생산량",
		width_lg: "width-lg-33",
		width_sm: "width-sm-50",
	},
	{
		data: "60,000",
		text: "월 입욕제 생산량",
		width_lg: "width-lg-33",
		width_sm: "width-sm-50",
	},
	{
		data: "ISO 22716",
		text: "화장품품질경영시스템인증서",
		width_lg: "width-lg-33",
		width_sm: "width-sm-50",
	},

	{
		data: "ISO 9001",
		text: "품질경영시스템인증서",
		width_lg: "width-lg-50",
		width_sm: "width-sm-50",
	},
	{
		data: "ISO 14001",
		text: "환경경영시스템인증서",
		width_lg: "width-lg-50",
		width_sm: "width-sm-50",
	},
	{
		data: "유기농 인증",
		text: "USDA ORGANIC (미국 농무부)",
		width_lg: "width-lg-50",
		width_sm: "width-sm-50",
	},
	{
		data: "이브비건 인증",
		text: "EVE VEGAN(프랑스)",
		width_lg: "width-lg-50",
		width_sm: "width-sm-50",
	},
	{
		data: "장애인표준사업장 인증",
		text: "한국장애인고용공단",
		width_lg: "width-lg-50",
		width_sm: "width-sm-50",
	},
	{
		data: "사회적기업 인증",
		text: "고용노동부",
		width_lg: "width-lg-50",
		width_sm: "width-sm-50",
	},
];

const drawOverviewList = () => {
	return overviewList.map((el, index) => {
		return (
			<div className={`list-overview ${el.width_lg} ${el.width_sm}`} key={`overviewList-${index}`}>
				<p className="overview-data">{el.data}</p>
				<p className="overview-text">{el.text}</p>
			</div>
		);
	});
};

const Overview = () => {
	return (
		<section className="Overview bgColor-lightGrey">
			<SectionTitle text={makeTitle(sectionTitle)} type="center" withText="false" />

			<div className="wrap-contents">
				<div className="con">
					<div className="wrap-list-overview">{drawOverviewList()}</div>
				</div>
			</div>
		</section>
	);
};

export default Overview;
